import { faText } from '@fortawesome/pro-light-svg-icons/faText';
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faCalendarStar } from '@fortawesome/pro-light-svg-icons/faCalendarStar';
import { faPhotoFilm } from '@fortawesome/pro-light-svg-icons/faPhotoFilm';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { SmartLinkWidgetType } from 'fym-common/src/db/enums';

export function getWidgetIconByWidgetType(type: SmartLinkWidgetType) {
  switch (type) {
    case SmartLinkWidgetType.info:
      return faText;
    case SmartLinkWidgetType.link:
      return faLink;
    case SmartLinkWidgetType.image:
      return faImage;
    case SmartLinkWidgetType.socialLinks:
      return faGlobe;
    case SmartLinkWidgetType.player:
      return faPlay;
    case SmartLinkWidgetType.profile:
      return faUser;
    case SmartLinkWidgetType.presave:
      return faCalendarStar;
    case SmartLinkWidgetType.media:
      return faPhotoFilm;
    case SmartLinkWidgetType.presaveSubscribe:
      return faUserPlus;
    default:
      // A block type that this build does not know (a newer server wrote it). A generic icon keeps
      // the Creator open; an error here would break the whole page.
      return faSquare;
  }
}
